import { grey, green, indigo } from '@mui/material/colors';

const validatedColor = (color) => (/^#([0-9A-Fa-f]{3}){1,2}$/.test(color) ? color : null);

export default (server, darkMode) => ({
  mode: darkMode ? 'dark' : 'light',
  background: {
    default: darkMode ? grey[900] : grey[50],
  },
  primary: {
    main: '#6179D3',
  },
  secondary: {
    main: '#fff',
  },
  neutral: {
    main: '#dddddd',
  },
  geometry: {
    main: '#3bb2d0',
  },
  darkGray: {
    main: '#5E6372',
  },
  darkBlue: {
    main: '#5A72CC',
  },
  yellow: {
    main: '#ffc465',
  },
});
